import { defineComponent as l, ref as _, computed as u, watch as m, createElementBlock as g, openBlock as y, normalizeStyle as d, unref as s, createElementVNode as r, createVNode as S, toDisplayString as i, withCtx as p, createTextVNode as f } from "vue";
import { c as o, n as H, e as v, L as x, o as A, p as I, u as b } from "./main-CBt6LPao.mjs";
import { _ as L } from "./SearchTermListbox.vue_vue_type_script_setup_true_lang-8PjIokKT.mjs";
const T = {
  class: "search-history__container"
}, B = {
  class: "search-history__container__middle"
}, R = {
  id: "search-history-heading",
  class: "search-history__header"
}, N = /* @__PURE__ */ l({
  __name: "SearchHistory",
  setup(C) {
    const a = _(null);
    function n(e) {
      if (A(e)) {
        I();
        return;
      }
      b(e.term);
    }
    const c = u(() => o.currentSuggestionType === H.SearchHistory);
    return m(c, () => {
      o.searchHistoryListboxSuggestions.length && requestAnimationFrame(() => {
        var t;
        (t = a.value) == null || t.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }), (e, t) => (y(), g("div", {
      ref_key: "searchHistoryRef",
      ref: a,
      class: "search-history",
      style: d({
        top: `${s(v).navHeight}px`
      })
    }, [r("div", T, [r("div", B, [r("h2", R, i(s(x).SEARCH_HISTORY), 1), S(L, {
      id: "gnav-recent-search-list",
      suggestions: s(o).searchHistoryListboxSuggestions,
      "aria-labelledby": "search-history-heading",
      onItemActivate: n
    }, {
      default: p(({
        item: h
      }) => [f(i(h.term), 1)]),
      _: 1
    }, 8, ["suggestions"])])])], 4));
  }
});
export {
  N as default
};
